import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {DropdownCategory} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownCategory';
import {TagModel} from '../../../../models/api/tagModel';
import {TagDropdownItem} from '../../../common/dropdowns/tagDropdownItem';

export enum SearchTagsDropdownItemTypes {
  SELECTED = 'selected',
  UNSELECTED = 'unselected',
  CATEGORY = 'category',
}

interface SelectedTagsItem {
  type: SearchTagsDropdownItemTypes.SELECTED;
  tags: ReadonlyArray<TagModel>;
}

interface CategoryItem {
  type: SearchTagsDropdownItemTypes.CATEGORY;
}

interface UnselectedTagsItem {
  type: SearchTagsDropdownItemTypes.UNSELECTED;
  tags: ReadonlyArray<TagModel>;
}

export type SearchTagsDropdownItem = SelectedTagsItem | CategoryItem | UnselectedTagsItem;

/*
 * Props.
 */

interface CellsRefinementOptionsSearchTagsDropdownRowProps {
  selectedTags: ReadonlyArray<TagModel> | undefined;
  onSelectTag: (model: TagModel) => void;
  isNotInteractive: boolean;
  shouldNest: boolean;
  item: SearchTagsDropdownItem;
}

/*
 * Component.
 */

export const CellsRefinementOptionsSearchTagsDropdownRow: FC<
  CellsRefinementOptionsSearchTagsDropdownRowProps
> = (props) => {
  const {onSelectTag, selectedTags, item, isNotInteractive, shouldNest} = props;

  if (item.type === SearchTagsDropdownItemTypes.CATEGORY) {
    return (
      <DropdownCategory>
        <Trans id="cells-refinement-options-search-tags-dropdown-category">All tags</Trans>
      </DropdownCategory>
    );
  }

  const tag = item.tags[0];
  const itemIsChecked =
    item.type === SearchTagsDropdownItemTypes.SELECTED || tag.id === selectedTags?.[0]?.id;
  const itemIsNotInteractive = item.type === SearchTagsDropdownItemTypes.SELECTED || isNotInteractive;

  const nestingLevel =
    shouldNest && item.type === SearchTagsDropdownItemTypes.UNSELECTED ? item.tags.length - 1 : 0;
  const tagsPath = shouldNest && item.type === SearchTagsDropdownItemTypes.UNSELECTED ? [] : item.tags;

  return (
    <TagDropdownItem
      key={tag.id}
      tag={tag}
      nestingLevel={nestingLevel}
      tagsPath={tagsPath}
      isChecked={itemIsChecked}
      isNotInteractive={itemIsNotInteractive}
      onSelect={() => {
        onSelectTag(tag);
      }}
    />
  );
};
